import { Flow } from 'flow-to-typescript-codemod';
import { SelectFilterChip } from 'common/ui/Chip/SelectFilterChip';
import type { FilterChipItem } from 'common/ui/Chip/SelectFilterChip';
import { OWNER_SCOPE } from '../useOwnerScope';
import type { TOwnerScope } from '../useOwnerScope';

const OWNER_ITEMS: ReadonlyArray<FilterChipItem<TOwnerScope>> = Object.freeze([
  {
    label: 'Personal',
    value: OWNER_SCOPE.Personal,
  },
  {
    label: 'Clinic',
    value: OWNER_SCOPE.Clinic,
  },
]);

export type OwnerFilterChipDropdownProps = {
  selected: TOwnerScope;
  disabled?: boolean;
  onSelect: (selected: TOwnerScope) => void;
};

export const OwnerFilterChipDropdown: Flow.AbstractComponent<
  OwnerFilterChipDropdownProps,
  undefined
> = (props) => {
  return (
    <SelectFilterChip
      size="xs"
      selected={props.selected}
      disabled={props.disabled}
      onSelect={props.onSelect}
      onClear={() => props.onSelect(OWNER_SCOPE.All)}
      items={OWNER_ITEMS}
      placeholder="Owner"
    />
  );
};
